// This file is part of the Smart Building Message Gateway.
//
//   |     __| _ _|   __|   _ \   \  |
//   |     _|    |   (     (   | |\/ |
//  ____| ___| ___| \___| \___/ _|  _|
//
// Copyright © 2025 LEICOM AG. All Rights Reserved.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
// BUT NOT LIMITED  TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// @author      Christian Stauffer <christian.stauffer@leicom.ch>, et al.

import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { LuBotMessageSquare } from "react-icons/lu";

import './Message.css'

function Message() {

  const location = useLocation();
  const navigate = useNavigate();

  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  const apiKey = window.env.API_KEY;
  const api = window.env.API_URL;

  const { token } = location.state || {};

  const [gateway, setGetGateway] = useState('');
  const [recipient, setRecipient] = useState('');
  const [message, setMessage] = useState('');

  const [dropdownGateways, setDropdownGateways] = useState([]);

  // get gatways
  useEffect(() => {
    async function fetchGateways() {
      try {   

        const response = await fetch(`${api}/gateways`, {
          method: "GET",
          headers: {
            "X-Api-Key": `${apiKey}`,
            "Authorization": `${token}`
          },
        });
        if (response.ok) {
          const gatewaysRaw = await response.json()
          const items = gatewaysRaw.map(item => `${item.id}: ${item.description}`);
          setDropdownGateways(items);
          console.log("Gateways",gatewaysRaw)
          navigate("/message", { state: { token }});
        } else {
          setError("Cannot fetch Gateways.");
        }

      } catch (err) {
        // handle empty response
        alert("network problems", err)
        return (<Navigate to="/login" />);
      }
    }
    fetchGateways();
  }, [api, apiKey, navigate, token]);
  
  const handleSendSms = async (e) => {
    e.preventDefault();
    if (recipient === '') {
      setError('missing recipient');
    } else if (message === '') {
      setError('missing message');
    } else {
      setError('');
      setInfo('');

      setLoading(true);

      const gwId = gateway.split(':')[0];
      console.log(gwId)

      try {      
        const response = await fetch(`${api}/send-sms?gw_id=${gwId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": `${apiKey}`,
            "Authorization": `${token}`
          },
          body: JSON.stringify({ recipients: [recipient], message: message } ),
        });
    
        if (response.ok) {
          setInfo('sms sent');
        } else if (response.status === 401) {
          navigate("/login");
        } else {
          setError("couldn't send sms");
        }
      } catch (err) {
        setError('network error')
        navigate("/login");
      } finally {
        setLoading(false)
      }
    }
  };

  return (
    <div className="page">
        <div className="header">
            <LuBotMessageSquare className="menu-icon" />
            <h2>Message</h2>
        </div>
        <br></br>
        <div className="body">
          <h2>SMS</h2>
          <p>Send SMS via RESTful API endpoint {api}/send-sms</p>
          
          <form onSubmit={handleSendSms}>
            
            <div className="form-group">
              <label className='form-group'>SMS Gateway</label>
              <select
                className='form-group'
                value={gateway}
                onChange={(e) => setGetGateway(e.target.value)}
              >
                <option value="">Select a Gateway</option>
                {dropdownGateways.map((gateway) => (
                  <option key={gateway} value={gateway}>
                    {gateway}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">

              <label className='body'>Recipient</label>
              <input
                className='body'
                type="text"
                id="recipient"
                value={recipient}
                onChange={(e) => setRecipient(e.target.value)}
                placeholder="+41774452356"
              />
            </div>
            <div className="form-group">
              <label className='body'>Message</label>
              <textarea
                className='body'
                type="text"
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Your message ..."
              />
            </div>
            {error && <p className="error-message">{error}</p>}
            {info && <p className="info-message">{info}</p>}
            
            <button type="submit" disabled={loading}>
              {loading ? (
                <div className="spinner"></div>
              ) : (
                'Send'
              )}
            </button>
          </form>
            
        </div>
        <br></br>
        <div className="body">
            <h2>Mail</h2>
            <p>This is the gateway page.</p>
        </div>
    </div>
  );
}

export default Message;
